export const scaledScore = (score) => {
    switch (parseInt(score)) {
        case 1:
            return 1;
        case 2:
            return 3;
        case 3:
            return 5;
        default:
            return undefined;
    }
};

export const onlyUniqueByKey = (key) => {
    return (value, index, array) => {
        return array.findIndex(item => item[key] === value[key]) === index;
    }
}

export const toSlug = (name) => name.toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[('_]/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-');

// controls nodes by keys: return final node if all keys are present, else return undefined
export const getNode = (summary, keys) => keys.reduce((acc, k) => acc && acc[k] ? acc[k] : undefined, summary);

// get attributions for map
const getProviderNames = (node) => {
    const providerNode = getNode(node, ['metadata', 'data_sources']);
    return providerNode ? [...new Set(providerNode.map(p => p.provider.name))].join(', ') : undefined
}

const getDocumentation = (node) => {
    const documentation = getNode(node, ['documentation']);
    return documentation ? `<p>${documentation}</p>` : undefined
}

export const getScore = (node, nodesNames) => {
    const data = getNode(node, [...nodesNames])
    if(Array.isArray(data)){
        return data.length > 0 ? parseInt(data.reduce((a, b) => a.percentage < b.percentage ? b : a).score) : undefined;
    }
    return data ? parseInt(data.score) : undefined
}

export const mountFormattedOverlay = (risk, data) => {
    let summaryRisk = risk.summaryRiskNode(data);
    const { summaryRiskNode, ...formattedRisk} = risk;
    // If node is missing, disable dataset
    if (summaryRisk === null || summaryRisk === undefined) {
        return {
            ...formattedRisk,
            disabled: true
        }
    }
    ['count', 'score', 'isPresent'].forEach(functionName => formattedRisk[functionName] && (formattedRisk[functionName] = formattedRisk[functionName](summaryRisk)))

    return {
        ...formattedRisk,
        hasMissingData: formattedRisk.hasMissingData ? formattedRisk.hasMissingData : getNode(summaryRisk, ['message']) != undefined,
        details: getDocumentation(summaryRisk),
        alternativeText: getNode(summaryRisk, ['alternativeText']),
        attributions: formattedRisk.attributions ? formattedRisk.attributions : getProviderNames(summaryRisk),
        disabled: (formattedRisk.hasOwnProperty("disable") && formattedRisk.disable(summaryRisk)) || false
    };
}

export const mountFormattedService = (service) => {
    return {
        id: toSlug(service.name),
        label: service.name,
        path: service._path
    }
}

//vector styles
export const pointStyle = (color, fillColor) => {
    return {        
        weight: 1,
        radius: 3,
        color: color,
        fillColor: fillColor ? fillColor : color,
        fillOpacity: 1,
        fill: true,
        radius: 6
    }
}

export const customStyle = (fileName) => {
    return {
        icon: L.icon({
            iconUrl: `/img/map/${fileName}.svg`,
            iconSize: [14, 14],
            iconAnchor: [0, 24],
            popupAnchor: [0, -36]
        })
    }
}

export const areaStyle = (color, fill) => {
    return {
        weight: 1,
        color: color,
        fillColor: color,
        fillOpacity: 0.65,
        fill: fill == undefined,
        stroke: false
    }
}

export const strokeStyle = (color, fillOpacity) => {
    return {
        weight: 1,
        color,
        fillOpacity,
        fill: true
    }
}